var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Button from '../Button';
/**
 * Table head cell component, include sort button. Can be used in Table component
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/develop/v0.3.0/components/datatable.md
 */
export default function SortableTableCell(_a) {
    var title = _a.title, orderBy = _a.orderBy, filters = _a.filters, handleSort = _a.handleSort;
    var additionalProps = {};
    if (orderBy) {
        var order = filters.sort
            ? (filters.order === 'asc' ? 'descending' : 'ascending')
            : (filters.order === 'asc' ? 'ascending' : 'descending');
        additionalProps['aria-label'] = "Sort by " + orderBy + " " + order;
    }
    return (React.createElement(Button, __assign({ className: "madonna-sortable-button", label: title, icon: orderBy !== filters.sort ? undefined : {
            size: 'xsmall',
            icon: filters.order === 'asc' ? 'arrow_upward' : 'arrow_downward',
        }, disableRipple: true, disabled: !orderBy, onClick: function () { orderBy && handleSort(orderBy); } }, additionalProps)));
}
//# sourceMappingURL=SortableTableCell.js.map